import { Link } from 'react-router-dom'
import MatchBar from './MatchBar'
import { User } from 'lucide-react'

const partyColors = {
  Democrat:    'bg-blue-100 text-blue-800',
  Republican:  'bg-red-100  text-red-800',
  Independent: 'bg-purple-100 text-purple-800',
}

export default function CandidateCard({ candidate, showMatch = false }) {
  const { id, name, party, state, district, office, matchScore } = candidate

  return (
    <div className="card flex flex-col gap-4 hover:shadow-md transition-shadow">
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-civitas-light text-civitas-blue shrink-0">
          <User className="h-6 w-6" />
        </div>
        <div>
          <h3 className="font-semibold text-civitas-navy">{name}</h3>
          <p className="text-xs text-civitas-silver">{state} · {district}</p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <span className={`badge ${partyColors[party] ?? 'bg-gray-100 text-gray-700'}`}>{party}</span>
        <span className="badge bg-gray-100 text-gray-600 truncate max-w-[180px]" title={office}>{office}</span>
      </div>
      {showMatch && matchScore !== undefined && (
        <div><MatchBar score={matchScore} label="Your match" /></div>
      )}
      <div className="flex gap-2 mt-auto pt-2">
        <Link to={`/candidates/${id}`} className="btn-secondary text-xs flex-1 text-center">View Profile</Link>
        <Link to={`/compare?a=${id}`} className="btn-primary text-xs flex-1 text-center">Compare</Link>
      </div>
    </div>
  )
}
